import { render, staticRenderFns } from "./RingDiagram.vue?vue&type=template&id=0ca2ebf8&scoped=true"
import script from "./RingDiagram.vue?vue&type=script&lang=js"
export * from "./RingDiagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca2ebf8",
  null
  
)

export default component.exports